import { AttributesMixin, define, Model, type } from '@type-r/models';
import { restfulIO } from './endpoint';

export interface CommunicationModel extends AttributesMixin<typeof CommunicationModel> {
}

@define
export class CommunicationModel extends Model {
  static endpoint = restfulIO('/api/communication/');

  intervalId: any

  static collection = {
    initialize() {
      setTimeout(() => { this.fetch() }, 3000)
      this.intervalId = setInterval(() => { this.fetch() }, 120000)
    },
    dispose() {
      clearInterval(this.intervalId)
    }
  }

  static attributes = {
    communicationId: Number,
    senderId: String,
    receiverId: String,
    read: Boolean,
    isActive: Boolean,
    subject: String,
    metadata: type({
      asset: String,
      dataCount: Number,
      dataArray: [type({
        invoiceId: String,
        InvoiceNumber: String,
        remittanceAdviceId: String
      })]
    })
      .dontSave
      .parse(x => typeof x === 'string' ? JSON.parse(x) : x),
    createdBy: String,
    createdOn: type(Date).dontSave,
    updatedBy: String,
    updatedOn: type(Date).null.dontSave,
  }

  static sortBy = {
    senderId: 'Sender Id',
    receiverId: 'Receiver Id',
    createdOnUtc: 'Created On',
  }

  static createFilter(category: CommunicationCategory | 'all', filter: string) {
    if (category == 'all')
      return x => x
    if (category == 'read')
      return x => x.read == true;
    if (category == 'unread')
      return x => x.read == false;
  }

  createUrl() {
    switch (this.metadata.asset) {
      case 'invoice':
        return this.metadata.id ? `/invoices/details/${this.metadata.id}` : '/invoices/all';
      case 'order':
        return this.metadata.id ? `/orders/${this.metadata.id}` : '/orders';
      case 'remittanceAdvice':
        return '/invoices/paymentinprogress';
      case 'statementOfAccount':
        return `/invoices/statement?relationshipId=${this.metadata.id}`;
      default:
        return '#';
    }
  }
}

const allCategories = {
  read: true,
  unread: true,
}

export type CommunicationCategory = 'read' | 'unread'
